import { api } from '../client';
import type { SearchResponse } from '@/types/search';

/*
 * Global search. Each type is searched only if the caller holds that type's own
 * view permission; the server decides, and returns up to five hits per type.
 *
 * Callers must not send a query shorter than SEARCH_MIN_QUERY_LENGTH — the
 * server answers 422.
 */
export const searchApi = {
  /**
   * `types` narrows the search; omitted or empty means every type the caller
   * may see. Sent comma-separated, which Spring binds to its Set<String>.
   */
  search: (q: string, types?: string[]) =>
    api.get<SearchResponse>('/search', {
      params: { q, types: types && types.length > 0 ? types.join(',') : undefined },
    }),
};
